/** Default number of chunk results shown in admin lookup UI. */
export const DEFAULT_MAX_RESULTS = 25

/** Preset max-result options (server hard cap is 100 for CHUNK_LOOKUP). */
export const MAX_RESULTS_OPTIONS = [10, 25, 50, 100] as const

/** Lead-in seconds applied before opening web-app watch links (Mosaic continue-watching pattern). */
export const CONTINUE_LEAD_IN_SECONDS = 5

export const PURPOSE_CHUNK_LOOKUP = 'CHUNK_LOOKUP'

export const DOCUMENT_SEMANTIC_SEARCH_LANGUAGE_OPTIONS = [
  { label: 'English', value: 'EN' },
  { label: 'Spanish', value: 'ES' },
  { label: 'German', value: 'DE' },
  { label: 'French', value: 'FR' },
] as const
